import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { ContactSourceOptions } from "../../../../cores/contacts/config";
import { useContactCore } from "../../../../cores/contacts";
import { AutomationCondition } from "../../../../cores/automations/interfaces/api/get-automation";
import { ConditionOperatorOptions } from "../../../../cores/automations/config";
import { LabelWembii } from "../../LabelWembii";
import { ContactSourceBadge } from "../../contacts/ContactSource";
import { ContactSource } from "../../../../cores/contacts/enum/ContactSource.enum";

interface Props {
  isFirst: Boolean;
  condition: AutomationCondition;
  onClick: () => void;
}

export default function Condition(props: Props) { 
  const intl = useIntl();
  const { condition, isFirst, onClick } = props;
  const { tags } = useContactCore();

  const tag = useMemo(() => 
    [
      ...ContactSourceOptions,
      ...tags.map((tag) => ({ value: tag.nameId, label: tag.name }))
    ].find((tag) => tag.value === condition.value)
  , [tags, condition]);

  const operator = useMemo(() => 
    ConditionOperatorOptions.find((operator) => operator.value === condition.operator)
  , [condition]);

  return (
    <div className="automation-condition-node">
      {!isFirst && (
        <div className="automation-condition-node__operator">
          {intl.formatMessage({ id: operator?.label })}
        </div>
      )}

      <button
        type="button"
        className="automation-condition-card"
        onClick={onClick}
      >
        <LabelWembii>
          {intl.formatMessage({ "id": "app.automations.condition.contact.source" })}
        </LabelWembii>
        <ContactSourceBadge source={tag?.value as ContactSource} />
      </button>
    </div>
  );
}